export class Role {
    public id = 0
    public name = ''

    constructor() { }
}